/**
 * Implementation of ButtonSettings page accessible at /dashboard/settings/button
 *
 * @author - Harsh Tomar
 */

// Dependencies
import Select from "../../components/Select";
import SettingCard, { Field } from "../../components/SettingCard";
import SettingsItem from "../../components/SettingsItem";

export default function ButtonSettings() {
  const buttonSettings: Field[] = [
    {
      label: "Button Position",
      value: "bottom-right",
      type: "TEXT",
    },
  ];

  const buttonEnabled = true;

  return (
    <div className="flex p-3" style={{ height: "calc(100vh - 8rem" }}>
      <div className="max-w-4xl pr-3" style={{ flex: 1 }}>
        <SettingCard heading="Button" editing={false}>
          <SettingsItem label="Visiblity">
            <p className="text-lg">
              <span
                className={`${
                  buttonEnabled ? "bg-green-400" : "bg-red-400"
                } px-2 py-1 font-semibold rounded-lg text-white text-sm uppercase`}
              >
                {buttonEnabled ? "Enabled" : "Disabled"}
              </span>
            </p>
          </SettingsItem>
          <SettingsItem label="Button Position">
            <Select options={["Bottom Right", "Bottom Left"]} />
          </SettingsItem>
          <SettingsItem label="Button Shape">
            <div className="flex">
              <div className="w-8 h-8 bg-gray-200 rounded-full mr-3" />
              <div className="w-8 h-8 bg-gray-200 rounded-lg mr-3" />
              <div className="w-8 h-8 bg-gray-200 rounded-tl-full rounded-b-full mr-3" style={{ borderTopRightRadius: 2000 }} />
              <div className="w-8 h-8 bg-gray-200 rounded-t-full rounded-bl-full mr-3" style={{ borderBottomRightRadius: 2000 }} />
            </div>
          </SettingsItem>
          <SettingsItem label="Button Icon">
            <p className="text-lg">🚀</p>
          </SettingsItem>
          <SettingsItem label="Button Text">
            <p className="text-lg">Help</p>
          </SettingsItem>
        </SettingCard>
      </div>

      <div className="rounded-xl flex-1 flex flex-col">
        <div className="max-h-96 bg-white flex-1 flex flex-col rounded-xl shadow">
          <div className="h-8 bg-gray-100 text-white px-4 rounded-t-xl">
            <span className="inline-block w-2 h-2 rounded-full bg-red-600 mr-2"></span>
            <span className="inline-block w-2 h-2 rounded-full bg-yellow-500 mr-2"></span>
            <span className="inline-block w-2 h-2 rounded-full bg-green-500 mr-2"></span>
          </div>
          <div className="p-4 relative flex-1 max-h-full overflow-hidden">
            <h1 className="text-2xl">Preview</h1>

            <div className="h-8 bg-gray-100 my-4 rounded"></div>
            {Array.from(Array(20).keys()).map((item) => (
              <div className="h-2 bg-gray-100 my-2 rounded"></div>
            ))}

            <div className="flex">
              <div className="flex-1 px-3">
                {Array.from(Array(15).keys()).map((item) => (
                  <div className="h-2 bg-gray-100 my-2 rounded"></div>
                ))}
              </div>
              <div className="flex-1 px-3">
                {Array.from(Array(15).keys()).map((item) => (
                  <div className="h-2 bg-gray-100 my-2 rounded"></div>
                ))}
              </div>
            </div>
          
            <button className="cursor-pointer h-10 px-4 text-white rounded-xl absolute shadow-md bottom-4 right-4 flex justify-center items-center bg-blue-700">
              🚀 Connect with Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
